import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { colors } from "@/utils/const";
import Link from "next/link";

export default function Ambition_Section() {
  const { t, locale } = useI18n();

  return (
    <Box
      id="Ambition"
      data-section="Ambition"
      sx={{
        backgroundColor: "white",
      }}
    >
      <Box className=" horizontal-safe-padding vertical-safe-padding">
        <Box
          sx={{
            backgroundImage: `url(${t.pages_main_tags.whyContact.ambition.bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: { xs: "right", md: "center" },
            height: { xs: "600px", md: "700px", lg: "855px" },
            display: "flex",
            justifyContent: "center",
            padding: { xs: "0 20px", md: "0" },
            borderRadius: "24px",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              mt: { xs: "15px", md: "40px" },
            }}
          >
            <Box
              component="img"
              alt={t.pages_main_tags.whyContact.ambition.title}
              src={t.pages_main_tags.whyContact.ambition.logo}
              sx={{
                margin: "50px 0 54px 0",
              }}
            />

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "32px",
              }}
            >
              <Box
                component="h2"
                sx={{
                  fontWeight: "bold",
                  color: "#fff",
                  fontSize: { xs: "30px", md: "40px", lg: "60px" },
                  maxWidth: "600px",
                  lineHeight: "110%",
                }}
              >
                {t.pages_main_tags.whyContact.ambition.title}
              </Box>

              <Box
                sx={{
                  fontWeight: "500",
                  color: colors.dark_white,
                  fontSize: { xs: "18px", md: "24px" },
                  maxWidth: "600px",
                  mx: "auto",
                }}
              >
                {t.pages_main_tags.whyContact.ambition.description}
              </Box>
            </Box>

            <Link href="/contact-us">
              <Button
                variant="contained"
                sx={{
                  mt: "54px",
                  padding: "12px 32px",
                  backgroundColor: colors.blue,
                  color: "#fff",
                  "&:hover": { backgroundColor: "#303F9F" },
                }}
              >
                {t.pages_main_tags.whyContact.ambition.btn}
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
